import Axios from '../data-access/genericAxios';
import { FemsGraph,MasterGraph,BemsGraph } from "../../utility/apiURLS";
import  ReArrangeLabel  from "../../components/commoncomponents/ReArrangeLabel";
async function getWorkGroupDetails(facilityId) {
  if(facilityId != undefined) {
  const response = await Axios.get(`${FemsGraph}/api/GraphWorkGroupDetails/GetWorkGroupDetailsByFacilityId/${facilityId}?size=1000`);
  if(response?.status === 200){
  const reArrangedData=ReArrangeLabel(response?.data,"wgcode","label")
  return reArrangedData;
  }
  return response;
  }
}
async function getMasters(facilityId,companyId) {
     const response = await Axios.get(`${MasterGraph}/api/masters/GetMasters/${companyId}/${facilityId}`);
       if(response?.status !== 'error'){
      const reArrangedData=ReArrangeLabel(response?.data?.masservicedetails,"service","label")
      return reArrangedData;
      }
      return response;
    }
    async function getMaintanenceYear(facilityId) {
      const response = await Axios.get(`${MasterGraph}/api/GraphMaintenanceYear/GetMaintenanceYearByFacilityId/${facilityId}?page=1&size=200`);
      if(response?.status === 200){
       const reArrangedData=ReArrangeLabel(response?.data.items,"maintyearvalue","label")
        return reArrangedData;
      }
      return response;
    }
    async function getBemsWorkGroupDetails(facilityId) {
      const response = await Axios.get(`${BemsGraph}/api/GraphWorkGroupDetails/GetWorkGroupDetailsByFacilityId/${facilityId}`);
      if(response?.status === 200){
      const reArrangedData=ReArrangeLabel(response?.data,"wgcode","label")
      return reArrangedData;
      }
      return response;
    }
const commonMasterRepository = {
      getWorkGroupDetails,
      getMasters,
      getMaintanenceYear,
      getBemsWorkGroupDetails,
      
    };
    
    
export default commonMasterRepository;